module.exports = __webpack_public_path__ + "static/img/banner5.1292852.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/callMe/banner5.png
// module id = Y10N
// module chunks = 1